import { EntityInterface } from '@app/shared/model/entity/interfaces/entityInterface.model';

export class ResetPassword implements EntityInterface {
    username: string;
    email: string;
}
